import { useEffect, useRef, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import { Pencil, Plus, Trash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddRoyalty from "./AddRoyalty";
import { Button } from "react-bootstrap";
import API from "../../utility/API-endPoints";
import { PiExport } from "react-icons/pi";
import Select from "react-select";
import PlotDateRangePicker from "../../components/PlotDatePicker/PlotDateRangePicker";

const headers: GridHeader[] = [
    {
        title: "Project Name",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Vendor Name",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Stock",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Quantity",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Royalty Date",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: "text-center",
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    },
];

const Royalty = () => {
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const nextOffset = useRef<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<GridRow[]>([]);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
    const [showAddAgent, setShowAddAgent] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>({});
    const [agentId, setAgentId] = useState<string>("");
    const [keyword, setKeyword] = useState<string>("");
    const [projectList, setProjectList] = useState<any[]>([]);
    const [isLoadingProject, setIsLoadingProject] = useState<boolean>(false);
    const [vendorList, setVendorList] = useState<any[]>([]);
    const [isLoadingVendor, setIsLoadingVendor] = useState<boolean>(false);
    const [selectedProject, setSelectedProject] = useState<string>("");
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [selectedVendor, setSelectedVendor] = useState<string>("");
    const [totalCount, setTotalCount] = useState<number>(0);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "INVENTORY"));
            !projectList.length && getProjectList();
            !vendorList.length && getVendorList();
        }
    }, [token])

    const getRoyaltyList = (
        offset: number,
        keyword?: string,
        startDatee?: Date,
        endDatee?: Date,
        order_by?: string,
        sort_by?: string
    ) => {
        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) {
            return;
        }
        nextOffset.current == 0 && setIsLoading(true);
        WebService.getAPI({
            action: `${API.ROYALTY_LIST}?limit=10&offset=${offset}&keyword=${keyword ? keyword : ""
                }&sort_by=${order_by ?? "asc"}&order_by=${sort_by ?? "created_at"}&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""
                }&project_id=${selectedProject}&vendor_id=${selectedVendor}`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                let rows: GridRow[] = [];
                for (var i in res.list) {
                    let columns: GridColumn[] = [];
                    columns.push({ value: res.list[i]?.project ? res.list[i]?.project?.project_name : "N/A" });
                    columns.push({ value: res.list[i]?.vendor ? res.list[i]?.vendor?.firm_name : "N/A" });
                    columns.push({ value: res.list[i]?.stock ? res.list[i]?.stock?.name : "N/A" });
                    columns.push({ value: (res.list[i]?.quantity && res.list[i]?.unit) ? `${res.list[i]?.quantity} ${res.list[i]?.unit?.name}` : "N/A" });
                    columns.push({ value: res.list[i].royalty_date ? HelperService.getFormatedDate(res.list[i].royalty_date) : "N/A" });
                    columns.push({ value: actionList(res.list[i]), type: "COMPONENT" });
                    rows.push({ data: columns });
                }
                setRows(rows);
                setKeyword(keyword ?? "");
                setTotalCount(res.count ?? 0);
            })
            .catch((e) => {
                setIsLoading(false);
            });
    };

    const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
        getRoyaltyList(
            offset,
            null as any,
            null as any,
            null as any,
            isAscending ? "asc" : "desc",
            key
        );
    };

    const actionList = (data: any) => {
        return (
            <div className="action-btns">
                {permissions && permissions.can_update && <>
                    <button
                        className="cursor-pointer  btn-edit btn"
                        onClick={() => onEdit(data)}
                    >
                        {" "}
                        <Pencil />{" "}
                    </button>
                </>}
                {permissions && permissions.can_delete && <button
                    onClick={() => onConfirmDelete(data)}
                    className="cursor-pointer btn btn-delete"
                >
                    {" "}
                    <Trash />{" "}
                </button>}
            </div>
        );
    };

    const onEdit = (val: any) => {
        setEditData(val);
        setShowAddAgent(true);
    };

    const onConfirmDelete = (val: any) => {
        setAgentId(val.uuid);
        setDeleteModal(true);
    };

    const onDelete = () => {
        setDeleteModal(false);
        setIsLoading(true);
        WebService.deleteAPI({
            action: `royalty/delete/${agentId}`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                toast.success(res.message);
                setAgentId("");
                getRoyaltyList(1);
            })
            .catch((e) => {
                setIsLoading(false);
                setAgentId("");
            });
    };

    const onCloseUserModal = (e: boolean) => {
        setShowAddAgent(false);
        setEditData({});
        e && getRoyaltyList(1);
    };

    const exportRoyalty = () => {
        WebService.getAPI({
            action: `royalty/export?keyword=${keyword ? keyword : ""}`,
            body: null,
            responseType: 'arraybuffer',
        }).then((response: any) => {
            const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `royalty_${new Date().toISOString()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch((e) => {
            toast.error("Failed to export royalty");
        });
    };

    const getProjectList = () => {
        setIsLoadingProject(true);
        WebService.getAPI({ action: "get/project/list" })
            .then((res: any) => {
                setProjectList(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.project_name } } }));
                setIsLoadingProject(false);
            })
            .catch((e: any) => { })
            .finally(() => {
                setIsLoadingProject(false);
            });
    };

    const getVendorList = () => {
        setIsLoadingVendor(true);
        WebService.getAPI({ action: "supplier/list" })
            .then((res: any) => {
                setVendorList(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.firm_name } } }));
                setIsLoadingVendor(false);
            }).catch((e: any) => { setIsLoadingVendor(false); })
    };

    return (
        <>
            <AddRoyalty isShow={showAddAgent} isClose={(e: boolean) => { onCloseUserModal(e); }} data={editData} projectList={projectList} vendorList={vendorList} />
            <DeleteModal isShow={showDeleteModal} close={() => { setDeleteModal(false); }} onDelete={() => { onDelete(); }} />
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center  mb-2"> <PageTitle title="Royalty" backArrow={true} />
                    <div>
                        {permissions && permissions.can_write && <Button className="btn btn-brand-1" onClick={() => { setEditData({}); setShowAddAgent(true); }}>
                            <Plus size={20} className="ms-1" /> Add Royalty
                        </Button>}
                        {permissions && permissions.can_write && permissions.can_update && <Button className="btn btn-brand-1 ms-2" onClick={() => { exportRoyalty(); }} >
                            <PiExport size={20} className="ms-1" /> Export Royalty
                        </Button>}
                    </div>
                </div>
                <div className="table-card">
                    {
                        <div className="row mb-3">
                            <div className="col-3">
                                <Select
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={projectList}
                                    onChange={(e: any) => { setSelectedProject(e ? e.value : ""); }}
                                    value={projectList?.find((option) => option.value === selectedProject)}
                                    placeholder="Select Project"
                                />
                            </div>
                            <div className="col-3">
                                <Select
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={vendorList}
                                    onChange={(e: any) => { setSelectedVendor(e ? e.value : ""); }}
                                    value={vendorList?.find((option) => option.value === selectedVendor)}
                                    placeholder="Select Vendor"
                                />
                            </div>
                            <div className="col-3">
                                <PlotDateRangePicker start_date={startDate} end_date={endDate} onDateChange={(start_date, end_date) => { setStartDate(start_date); setEndDate(end_date); }} />
                            </div>
                            <div className="col-3"> <Button className="btn-brand-1" onClick={() => { getRoyaltyList(1) }} >  Search </Button>  </div>
                        </div>
                    }
                    <Grid
                        rows={rows}
                        headers={headers}
                        showDateFilter={false}
                        onPageChange={getRoyaltyList}
                        errorMessage={"No Royalty Found"}
                        ShowLoader={isLoading}
                        onSort={onSortList}
                        count={totalCount}
                    />
                </div>
            </div>}
        </>
    );
};

export default Royalty;
